import toast from '../common/toast';
import api from '../js/api';
import logreg from '../js/logreg';
export default {
  name: 'actwrap',
  props: {
    name: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    },
    wayType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      password: '',
      code: '',
      act: false,
      toastState: false,
      txt: 'You are not certified'
    };
  },
  components: {
    'toast-pop': toast
  },
  methods: {
    register: function register() {
      var _this = this;
      api.isActiveEmail(this.token).then(function (data) {
        if (data.ret === '1' && data.data && data.data.is_active === '0') {
          // {{ $t($loginLangPrefix('userSign.notActive')) }}
          _this.showPop(_this.$t(_this.$loginLangPrefix('userSign.notActive')));
        } else {
          // 登录 accessToken, regType, keep = 0, callback
          logreg.userInfo(_this.token, logreg.REGTYPE.email, 1, function (state, udata) {
            if (state === 'success') {
              _this.$emit('success', udata);
            } else if (window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf("".concat(udata.status)) >= 0 || window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf(udata.data && "".concat(udata.data.status)) >= 0) {
              // this.showPop(this.$t(this.$loginLangPrefix('userSign.fkError')));
            } else if (data.errorMessageTMXTip) {
              //
            } else {
              _this.showPop(_this.$t(_this.$loginLangPrefix('userSign.sysError')));
            }
          }, _this.name);
        }
      }).catch(function (response) {
        console.log(response);
      });
    },
    resend: function resend() {
      var _this2 = this;
      api.sendEmail(this.name, 0, this.token).then(function () {
        _this2.showPop(_this2.$t(_this2.$loginLangPrefix('userSign.emailsended')));
      }).catch(function (response) {
        console.log(response);
      });
    },
    showPop: function showPop(txt) {
      var _this3 = this;
      this.txt = txt;
      this.toastState = true;
      setTimeout(function () {
        _this3.txt = '';
        _this3.toastState = false;
      }, 1500);
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};